import React from 'react';

const EnquiryConfirmation = ({ }) => {  

    return (
        <>
            <style>
                {`

                
                `}
            </style>

            <div style={{display: 'flex'}}>
                <div>
                    <h3 className="mt-3">Thank you for your enquiry</h3>
                    <p>Your enquiry has been sent to the restaurant. We aim to get back to you within 24 hours.</p>
                </div>
                <div>
                    <img></img>
                </div>
            </div>
            
        </>);

}

export default EnquiryConfirmation;